import * as React from "react"
import { CollectionSearch } from "./collection-search"
import type { CollectionSearchProps } from "./types"

export interface TagSearchProps
  extends Omit<CollectionSearchProps, "collection" | "displayMode"> {
  /** Additional filter beyond default tag filtering */
  filter?: Record<string, any>
}

/**
 * TagSearch - Pre-configured CollectionSearch for tags.
 *
 * @example
 * <TagSearch
 *   value={tagId}
 *   onChange={(option) => setTagId(option?.value || null)}
 *   placeholder="Select a tag..."
 * />
 */
export function TagSearch({
  placeholder = "Search tags...",
  ...props
}: TagSearchProps) {
  return (
    <CollectionSearch
      {...props}
      collection="tags"
      displayMode="default"
      placeholder={placeholder}
    />
  )
}
